<template>
  <section class="section my-24 pt-0">
    <div class="container">
      <div v-for="group in groups" :key="group.year" class="news-list">
        <h2 class="title typo-h2">{{ group.year }}</h2>
        <div class="news-list-items">
          <div
            v-for="item in group.items"
            :key="item.nid"
            class="teaser-listable"
          >
            <teaser
              :title="item.title"
              :to="item.to"
              :tagline="item.tagline"
              :body="item.lead"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { NewsListItemFragment } from '#graphql-operations'

defineBlokkliFragment({
  name: 'news_list',
  label: 'All News',
})

const { data: groups } = await useAsyncGraphqlQuery('newsList', null, {
  transform: function (data) {
    const items = (data.data.entityQuery.items || [])
      .filter((v): v is NewsListItemFragment & { __typename: 'NodeNews' } => {
        return v !== null && v.__typename === 'NodeNews'
      })
      .map((item) => {
        const year = item.year?.first?.formatted || ''
        const date = item.date?.first?.formatted || ''
        const topic = item.referencedTopic?.title || ''

        return {
          year,
          nid: item.id || '',
          to: item.url?.path || '',
          title: item.title || '',
          lead: item.intro || '',
          tagline: [date, topic].filter(Boolean).join(' - '),
          timestamp: parseInt(item.timestamp?.first?.formatted || '') || 0,
        }
      })

    const map = items.reduce<Record<string, typeof items>>((acc, item) => {
      if (!acc[item.year]) {
        acc[item.year] = []
      }
      acc[item.year]!.push(item)
      return acc
    }, {})

    return Object.keys(map)
      .sort((a, b) => {
        return parseInt(b) - parseInt(a)
      })
      .map((year) => {
        const items = map[year]
        if (!items) return { year, items: [] }

        return {
          year,
          items: items.sort((a, b) => {
            return b.timestamp - a.timestamp
          }),
        }
      })
  },
})
</script>

<style lang="postcss">
.news-list-items {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: var(--grid-gap);
}

.news-list + .news-list {
  margin-top: calc(var(--grid-gap) * 3);
}
</style>
